import makeStyles from '@mui/styles/makeStyles'
import { MyAccountTheme, MaTabContainerClasses } from '@dxp-module/themes'

const tabContainerStyles = makeStyles<
  MyAccountTheme,
  object,
  MaTabContainerClasses
>(
  () => ({
    root: {},
    tab: {
      width: '50%',
      maxWidth: 'unset',
    },
    tabs: {
      width: '100%',
    },
    tabPanel: {},
    tabText: {},
  }),
  { name: 'MyAccount_TabContainer' }
)

export default tabContainerStyles
